module.exports = __webpack_public_path__ + "img/ObenImSchachtFuesseObenTransp.dd578146.png";